import siteApi from '../clients/site';

export const verifyAndActivateMfa = async (secret: string, mfaCode: string) => {
  await siteApi.post<void>(`/mfa`, {
    secret,
    mfaCode,
  });
};
